import { type ReactNode } from "react";
import { ChevronIcon } from "../icons/ChevronIcon";

interface CollapsibleSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
}

export function CollapsibleSection({ title, expanded, onToggle, children }: CollapsibleSectionProps): JSX.Element {
  return (
    <div className="collapsible-section">
      <button
        type="button"
        className="collapsible-section__header"
        onClick={onToggle}
        aria-expanded={expanded}
      >
        <span className="collapsible-section__title">{title}</span>
        <span
          aria-hidden="true"
          className={`collapsible-section__chevron${expanded ? " collapsible-section__chevron--open" : ""}`}
        >
          <ChevronIcon />
        </span>
      </button>
      {expanded ? <div className="collapsible-section__body">{children}</div> : null}
    </div>
  );
}
